export default "__VITE_ASSET__D5G8fcZ___"